export const iconFontAwesomeFilesCopy = (
	<i className="fa-solid fa-copy"></i>
);
